/** Generated by npm run languages:sync from Logto v1.43.0 (d066df7d26d596b6ba7ad0bdfaaecfda9c612226).
 * Names: packages/toolkit/language-kit/src/const.ts
 * Inventory: packages/phrases-experience/src/index.ts
 * Order: packages/console/src/hooks/use-ui-languages.ts
 * Phrases: packages/phrases-experience/src/locales; upstream MPL-2.0 licensed (see infra/logto/LOGTO-LICENSE).
 * Do not edit directly. */
export const officialLanguages = [
  { code: 'ar', label: 'العربية', tag: 'ar', native: 'ar' },
  { code: 'cs', label: 'Čeština', tag: 'cs', native: 'cs' },
  { code: 'de', label: 'Deutsch', tag: 'de', native: 'de' },
  { code: 'en', label: 'English', tag: 'en', native: 'en' },
  { code: 'es', label: 'Español', tag: 'es', native: 'es' },
  { code: 'es-MX', label: 'Español (México)', tag: 'es-MX', native: 'es-MX' },
  { code: 'fa-IR', label: 'فارسی', tag: 'fa-IR', native: 'fa-IR' },
  { code: 'fr', label: 'Français', tag: 'fr', native: 'fr' },
  { code: 'it', label: 'Italiano', tag: 'it', native: 'it' },
  { code: 'ja', label: '日本語', tag: 'ja', native: 'ja' },
  { code: 'ko', label: '한국어', tag: 'ko', native: 'ko' },
  { code: 'pl-PL', label: 'Polski', tag: 'pl-PL', native: 'pl-PL' },
  { code: 'pt', label: 'Português (Brasil)', tag: 'pt-BR', native: 'pt-BR' },
  { code: 'pt-PT', label: 'Português (Portugal)', tag: 'pt-PT', native: 'pt-PT' },
  { code: 'ru', label: 'Русский', tag: 'ru', native: 'ru' },
  { code: 'th', label: 'ไทย', tag: 'th', native: 'th' },
  { code: 'tr-TR', label: 'Türkçe', tag: 'tr-TR', native: 'tr-TR' },
  { code: 'uk-UA', label: 'Українська', tag: 'uk-UA', native: 'uk-UA' },
  { code: 'zh', label: '简体中文', tag: 'zh-CN', native: 'zh-CN' },
  { code: 'zh-HK', label: '繁體中文（香港）', tag: 'zh-HK', native: 'zh-HK' },
  { code: 'zh-TW', label: '繁體中文（台灣）', tag: 'zh-TW', native: 'zh-TW' },
] as const;
export const officialMessages = {
  ar: {
    otherMethods: 'أو',
    account: 'الحساب',
    create: 'إنشاء حساب',
    codeSignIn: 'تسجيل الدخول باستخدام رمز التحقق',
    employee: 'تسجيل الدخول الموحد',
    email: 'البريد الإلكتروني',
    profileTitle: 'المعلومات الشخصية',
    profileDescription: 'قم بتغيير معلوماتك الشخصية هنا.',
    securityLink: 'الأمان',
    details: 'المعلومات الشخصية',
    avatar: 'الصورة الرمزية',
    avatarEdit: 'تغيير الصورة الرمزية',
    avatarSave: 'حفظ',
    cancel: 'إلغاء',
    continueWith: 'تسجيل الدخول باستخدام {name}',
    continueGoogle: 'تسجيل الدخول باستخدام Google',
    continueGithub: 'تسجيل الدخول باستخدام GitHub',
    signInAction: 'تسجيل الدخول',
    signOutAction: 'تسجيل الخروج',
    loading: 'جارٍ التحميل...',
  },
  cs: {
    otherMethods: 'nebo',
    account: 'Účet',
    create: 'Vytvořit účet',
    codeSignIn: 'Přihlásit se ověřovacím kódem',
    employee: 'Single Sign-On',
    email: 'E-mailová adresa',
    profileTitle: 'Osobní informace',
    profileDescription: 'Zde změňte své osobní údaje.',
    securityLink: 'Zabezpečení',
    details: 'Osobní informace',
    avatar: 'Profilový obrázek',
    avatarEdit: 'Změnit Profilový obrázek',
    avatarSave: 'Uložit',
    cancel: 'Zrušit',
    continueWith: 'Pokračovat s {name}',
    continueGoogle: 'Pokračovat s Google',
    continueGithub: 'Pokračovat s GitHub',
    signInAction: 'Přihlásit se',
    signOutAction: 'Odhlásit se',
    loading: 'Načítání...',
  },
  de: {
    otherMethods: 'oder',
    account: 'Konto',
    create: 'Konto erstellen',
    codeSignIn: 'Mit Bestätigungscode anmelden',
    employee: 'Single Sign-On',
    email: 'Email',
    profileTitle: 'Persönliche Informationen',
    profileDescription: 'Ändere hier deine persönlichen Informationen.',
    securityLink: 'Sicherheit',
    details: 'Persönliche Informationen',
    avatar: 'Avatar',
    avatarEdit: 'Avatar ändern',
    avatarSave: 'Speichern',
    cancel: 'Abbrechen',
    continueWith: 'Mit {name} anmelden',
    continueGoogle: 'Mit Google anmelden',
    continueGithub: 'Mit GitHub anmelden',
    signInAction: 'Anmelden',
    signOutAction: 'Abmelden',
    loading: 'Laden...',
  },
  en: {
    otherMethods: 'or',
    account: 'Account',
    create: 'Create account',
    codeSignIn: 'Sign in with verification code',
    employee: 'Single Sign-On',
    email: 'Email',
    profileTitle: 'Personal info',
    profileDescription: 'Change your personal information here.',
    securityLink: 'Security',
    details: 'Personal info',
    avatar: 'Avatar',
    avatarEdit: 'Change Avatar',
    avatarSave: 'Save',
    cancel: 'Cancel',
    continueWith: 'Continue with {name}',
    continueGoogle: 'Continue with Google',
    continueGithub: 'Continue with GitHub',
    signInAction: 'Sign in',
    signOutAction: 'Sign out',
    loading: 'Loading...',
  },
  es: {
    otherMethods: 'o',
    account: 'Cuenta',
    create: 'Crear una cuenta',
    codeSignIn: 'Iniciar sesión con código de verificación',
    employee: 'Inicio de sesión único',
    email: 'Correo electrónico',
    profileTitle: 'Información personal',
    profileDescription: 'Cambia tu información personal aquí.',
    securityLink: 'Seguridad',
    details: 'Información personal',
    avatar: 'Avatar',
    avatarEdit: 'Cambiar Avatar',
    avatarSave: 'Guardar',
    cancel: 'Cancelar',
    continueWith: 'Continuar con {name}',
    continueGoogle: 'Continuar con Google',
    continueGithub: 'Continuar con GitHub',
    signInAction: 'Iniciar sesión',
    signOutAction: 'Cerrar sesión',
    loading: 'Cargando...',
  },
  'es-MX': {
    otherMethods: 'o',
    account: 'Cuenta',
    create: 'Crear una cuenta',
    codeSignIn: 'Iniciar sesión con código de verificación',
    employee: 'Inicio de sesión único',
    email: 'Correo electrónico',
    profileTitle: 'Información personal',
    profileDescription: 'Cambia tu información personal aquí.',
    securityLink: 'Seguridad',
    details: 'Información personal',
    avatar: 'Avatar',
    avatarEdit: 'Cambiar Avatar',
    avatarSave: 'Guardar',
    cancel: 'Cancelar',
    continueWith: 'Continuar con {name}',
    continueGoogle: 'Continuar con Google',
    continueGithub: 'Continuar con GitHub',
    signInAction: 'Iniciar sesión',
    signOutAction: 'Cerrar sesión',
    loading: 'Cargando...',
  },
  'fa-IR': {
    otherMethods: 'یا',
    account: 'حساب',
    create: 'ایجاد حساب کاربری',
    codeSignIn: 'ورود با کد تأیید',
    employee: 'ورود یکپارچه',
    email: 'ایمیل',
    profileTitle: 'اطلاعات شخصی',
    profileDescription: 'اطلاعات شخصی خود را اینجا تغییر دهید.',
    securityLink: 'امنیت',
    details: 'اطلاعات شخصی',
    avatar: 'تصویر نمایه',
    avatarEdit: 'تغییر تصویر نمایه',
    avatarSave: 'ذخیره',
    cancel: 'لغو',
    continueWith: 'ادامه با {name}',
    continueGoogle: 'ادامه با Google',
    continueGithub: 'ادامه با GitHub',
    signInAction: 'ورود',
    signOutAction: 'خروج',
    loading: 'در حال بارگذاری...',
  },
  fr: {
    otherMethods: 'ou',
    account: 'Compte',
    create: 'Créer un compte',
    codeSignIn: 'Se connecter avec le code de vérification',
    employee: 'Connexion unique',
    email: 'Email',
    profileTitle: 'Informations personnelles',
    profileDescription: 'Changez vos informations personnelles ici.',
    securityLink: 'Sécurité',
    details: 'Informations personnelles',
    avatar: 'Avatar',
    avatarEdit: 'Changer Avatar',
    avatarSave: 'Enregistrer',
    cancel: 'Annuler',
    continueWith: 'Continuer avec {name}',
    continueGoogle: 'Continuer avec Google',
    continueGithub: 'Continuer avec GitHub',
    signInAction: 'Connexion',
    signOutAction: 'Se déconnecter',
    loading: 'Chargement...',
  },
  it: {
    otherMethods: 'o',
    account: 'Account utente',
    create: 'Crea account',
    codeSignIn: 'Accedi con il codice di verifica',
    employee: 'Single Sign-On',
    email: 'Email',
    profileTitle: 'Informazioni personali',
    profileDescription: 'Modifica qui le tue informazioni personali.',
    securityLink: 'Sicurezza',
    details: 'Informazioni personali',
    avatar: 'Avatar',
    avatarEdit: 'Cambia Avatar',
    avatarSave: 'Salva',
    cancel: 'Annulla',
    continueWith: 'Continua con {name}',
    continueGoogle: 'Continua con Google',
    continueGithub: 'Continua con GitHub',
    signInAction: 'Accedi',
    signOutAction: 'Esci',
    loading: 'Caricamento...',
  },
  ja: {
    otherMethods: 'または',
    account: 'アカウント',
    create: 'アカウントを作成する',
    codeSignIn: '認証コードでサインインする',
    employee: 'シングルサインオン',
    email: 'メールアドレス',
    profileTitle: '個人情報',
    profileDescription: 'ここで個人情報を変更できます。',
    securityLink: 'セキュリティ',
    details: '個人情報',
    avatar: 'アバター',
    avatarEdit: 'アバター を変更する',
    avatarSave: '保存',
    cancel: 'キャンセル',
    continueWith: '{name} で続ける',
    continueGoogle: 'Google で続ける',
    continueGithub: 'GitHub で続ける',
    signInAction: 'サインイン',
    signOutAction: 'サインアウト',
    loading: '読み込み中...',
  },
  ko: {
    otherMethods: '또는',
    account: '계정',
    create: '계정 생성',
    codeSignIn: '인증번호로 로그인',
    employee: '단일 로그인',
    email: '이메일',
    profileTitle: '개인 정보',
    profileDescription: '여기에서 개인 정보를 변경하세요.',
    securityLink: '보안',
    details: '개인 정보',
    avatar: '아바타',
    avatarEdit: '변경 아바타',
    avatarSave: '저장',
    cancel: '취소',
    continueWith: '{name} 계속',
    continueGoogle: 'Google 계속',
    continueGithub: 'GitHub 계속',
    signInAction: '로그인',
    signOutAction: '로그아웃',
    loading: '로딩 중...',
  },
  'pl-PL': {
    otherMethods: 'lub',
    account: 'Konto',
    create: 'Utwórz konto',
    codeSignIn: 'Zaloguj się za pomocą kodu weryfikacyjnego',
    employee: 'Pojedyncze logowanie',
    email: 'E-mail',
    profileTitle: 'Informacje osobiste',
    profileDescription: 'Zmień swoje dane osobowe tutaj.',
    securityLink: 'Bezpieczeństwo',
    details: 'Informacje osobiste',
    avatar: 'Avatar',
    avatarEdit: 'Zmień Avatar',
    avatarSave: 'Zapisz',
    cancel: 'Anuluj',
    continueWith: 'Kontynuuj z {name}',
    continueGoogle: 'Kontynuuj z Google',
    continueGithub: 'Kontynuuj z GitHub',
    signInAction: 'Zaloguj się',
    signOutAction: 'Wyloguj się',
    loading: 'Ładowanie...',
  },
  pt: {
    otherMethods: 'ou',
    account: 'Conta',
    create: 'Criar conta',
    codeSignIn: 'Fazer login com código de verificação',
    employee: 'Single Sign-On',
    email: 'E-mail',
    profileTitle: 'Informações pessoais',
    profileDescription: 'Altere suas informações pessoais aqui.',
    securityLink: 'Segurança',
    details: 'Informações pessoais',
    avatar: 'Avatar',
    avatarEdit: 'Alterar Avatar',
    avatarSave: 'Salvar',
    cancel: 'Cancelar',
    continueWith: 'Continuar com {name}',
    continueGoogle: 'Continuar com Google',
    continueGithub: 'Continuar com GitHub',
    signInAction: 'Entrar',
    signOutAction: 'Sair',
    loading: 'Carregando...',
  },
  'pt-PT': {
    otherMethods: 'ou',
    account: 'Conta',
    create: 'Criar uma conta',
    codeSignIn: 'Iniciar sessão com código de verificação',
    employee: 'Logon Único',
    email: 'Email',
    profileTitle: 'Informações pessoais',
    profileDescription: 'Altere as suas informações pessoais aqui.',
    securityLink: 'Segurança',
    details: 'Informações pessoais',
    avatar: 'Avatar',
    avatarEdit: 'Alterar Avatar',
    avatarSave: 'Guardar',
    cancel: 'Cancelar',
    continueWith: 'Continuar com {name}',
    continueGoogle: 'Continuar com Google',
    continueGithub: 'Continuar com GitHub',
    signInAction: 'Entrar',
    signOutAction: 'Terminar sessão',
    loading: 'A carregar...',
  },
  ru: {
    otherMethods: 'или',
    account: 'Аккаунт',
    create: 'Создать аккаунт',
    codeSignIn: 'Войти с кодом подтверждения',
    employee: 'Единый вход',
    email: 'Электронная почта',
    profileTitle: 'Личная информация',
    profileDescription: 'Измените здесь свою личную информацию.',
    securityLink: 'Безопасность',
    details: 'Личная информация',
    avatar: 'Аватар',
    avatarEdit: 'Изменить Аватар',
    avatarSave: 'Сохранить',
    cancel: 'Отменить',
    continueWith: 'Войти через {name}',
    continueGoogle: 'Войти через Google',
    continueGithub: 'Войти через GitHub',
    signInAction: 'Войти',
    signOutAction: 'Выйти',
    loading: 'Загрузка...',
  },
  th: {
    otherMethods: 'หรือ',
    account: 'บัญชี',
    create: 'สร้างบัญชี',
    codeSignIn: 'เข้าสู่ระบบด้วยรหัสยืนยัน',
    employee: 'เข้าสู่ระบบ SSO',
    email: 'อีเมล',
    profileTitle: 'ข้อมูลส่วนบุคคล',
    profileDescription: 'เปลี่ยนข้อมูลส่วนบุคคลของคุณที่นี่',
    securityLink: 'ความปลอดภัย',
    details: 'ข้อมูลส่วนบุคคล',
    avatar: 'Avatar',
    avatarEdit: 'เปลี่ยน Avatar',
    avatarSave: 'บันทึก',
    cancel: 'ยกเลิก',
    continueWith: 'เข้าสู่ระบบด้วย {name}',
    continueGoogle: 'เข้าสู่ระบบด้วย Google',
    continueGithub: 'เข้าสู่ระบบด้วย GitHub',
    signInAction: 'เข้าสู่ระบบ',
    signOutAction: 'ออกจากระบบ',
    loading: 'กำลังโหลด...',
  },
  'tr-TR': {
    otherMethods: 'veya',
    account: 'Hesap',
    create: 'Hesap Oluştur',
    codeSignIn: 'Doğrulama koduyla oturum açın',
    employee: 'Tek oturum açma',
    email: 'E-posta Adresi',
    profileTitle: 'Kişisel bilgiler',
    profileDescription: 'Kişisel bilgilerinizi burada değiştirin.',
    securityLink: 'Güvenlik',
    details: 'Kişisel bilgiler',
    avatar: 'Avatar',
    avatarEdit: 'Avatar değiştir',
    avatarSave: 'Kaydet',
    cancel: 'İptal Et',
    continueWith: '{name} ile ilerle',
    continueGoogle: 'Google ile ilerle',
    continueGithub: 'GitHub ile ilerle',
    signInAction: 'Giriş Yap',
    signOutAction: 'Oturumu kapat',
    loading: 'Yükleniyor...',
  },
  'uk-UA': {
    otherMethods: 'або',
    account: 'Акаунт',
    create: 'Створити обліковий запис',
    codeSignIn: 'Увійти за допомогою коду підтвердження',
    employee: 'Єдиний вхід (SSO)',
    email: 'Електронна пошта',
    profileTitle: 'Особиста інформація',
    profileDescription: 'Змініть свою особисту інформацію тут.',
    securityLink: 'Безпека',
    details: 'Особиста інформація',
    avatar: 'Аватар',
    avatarEdit: 'Змінити Аватар',
    avatarSave: 'Зберегти',
    cancel: 'Скасувати',
    continueWith: 'Продовжити з {name}',
    continueGoogle: 'Продовжити з Google',
    continueGithub: 'Продовжити з GitHub',
    signInAction: 'Увійти',
    signOutAction: 'Вийти',
    loading: 'Завантаження...',
  },
  zh: {
    otherMethods: '或',
    account: '账户',
    create: '注册',
    codeSignIn: '用验证码登录',
    employee: '单点登录',
    email: '邮箱',
    profileTitle: '个人信息',
    profileDescription: '在这里更改你的个人信息。',
    securityLink: '安全',
    details: '个人信息',
    avatar: '头像',
    avatarEdit: '更改头像',
    avatarSave: '保存',
    cancel: '取消',
    continueWith: '通过 {name} 继续',
    continueGoogle: '通过 Google 继续',
    continueGithub: '通过 GitHub 继续',
    signInAction: '登录',
    signOutAction: '退出登录',
    loading: '加载中...',
  },
  'zh-HK': {
    otherMethods: '或',
    account: '帳戶',
    create: '註冊',
    codeSignIn: '用驗證碼登錄',
    employee: '單點登錄',
    email: '電郵',
    profileTitle: '個人資料',
    profileDescription: '在這裡更改你的個人資訊。',
    securityLink: '安全',
    details: '個人資料',
    avatar: '頭像',
    avatarEdit: '更改頭像',
    avatarSave: '儲存',
    cancel: '取消',
    continueWith: '通過 {name} 繼續',
    continueGoogle: '通過 Google 繼續',
    continueGithub: '通過 GitHub 繼續',
    signInAction: '登錄',
    signOutAction: '登出',
    loading: '載入中...',
  },
  'zh-TW': {
    otherMethods: '或',
    account: '帳戶',
    create: '註冊',
    codeSignIn: '用驗證碼登錄',
    employee: '單點登錄',
    email: '電子郵件',
    profileTitle: '個人資料',
    profileDescription: '在這裡變更你的個人資訊。',
    securityLink: '安全',
    details: '個人資料',
    avatar: '頭像',
    avatarEdit: '更改頭像',
    avatarSave: '儲存',
    cancel: '取消',
    continueWith: '通過 {name} 繼續',
    continueGoogle: '通過 Google 繼續',
    continueGithub: '通過 GitHub 繼續',
    signInAction: '登錄',
    signOutAction: '登出',
    loading: '載入中...',
  },
};
